import basicTheme from '../basicTheme.js';

const accordionSummaryStyleOverrides = {
    styleOverrides: {
        root: {
            borderRadius: '4px',
            minHeight: '34px',
            '&.Mui-expanded': {
                minHeight: '34px',
            },
            '&.Mui-disabled': {
                background: basicTheme.palette.N50.main,
                '& > .MuiAccordionSummary-expandIconWrapper': {
                    display: 'none',
                },
                '&:hover': {
                    background: basicTheme.palette.N50.main,
                },
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
                marginLeft: '8px',
            },
        },
        content: {
            margin: '0px',
            '&.Mui-expanded': {
                margin: '0',
            },
        },
    },
};

export { accordionSummaryStyleOverrides as default };
//# sourceMappingURL=MuiAccordionSummary.js.map
